import React from "react";
import { CardMedia, Chip, Stack, Typography } from "@mui/material";

import { CardActionArea, CardContent } from "@mui/material";

import { Card } from "@mui/material";

interface Props {
  link: string;
  image: string;
  title: string;
  description: string;
  hasBetaTag?: boolean;
}

export default function AdditionalToolsCard(props: Props) {
  const { link, image, title, description, hasBetaTag = false } = props;

  return (
    <Card sx={{ maxWidth: "368px" }}>
      <CardActionArea href={link}>
        <Stack direction="row">
          <CardMedia>
            <img height="100%" alt={title} src={image} />
          </CardMedia>
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Stack direction="row" justifyContent="space-between">
              <Typography variant="body1" fontWeight="700">
                {title}
              </Typography>
              {hasBetaTag && <Chip label="BETA" color="primary" size="small" />}
            </Stack>
            <Typography variant="body2">{description}</Typography>
          </CardContent>
        </Stack>
      </CardActionArea>
    </Card>
  );
}
